import { connect } from "react-redux";

import type { NapiUser } from "@app/types/napi-types";

import { AccountItem as AccountItemComponent } from "./account-item";

const mapStateToProps = (state: { user?: NapiUser }) => {
  const { user } = state;
  return {
    user
  };
};

export const AccountItem = connect(mapStateToProps)(AccountItemComponent);
